module.exports = __webpack_public_path__ + "static/media/gnome_line.d2a095d8.svg";